import '@/i18n/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/router';
import { BootstrapGate } from '@/config/BootstrapGate';
import { AdminThemeProvider } from '@/theme';
import '@/theme/fonts'; // self-hosted fonts

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <AdminThemeProvider>
      {/* BootstrapGate resolves the platform bootstrap (login/auth/brand/asset
          origins) BEFORE the router renders at all, so no branded chrome paints
          and no redirect decision (e.g. AuthGate's centralized-login redirect)
          is made before those origins are known. */}
      <BootstrapGate>
        <RouterProvider router={router} />
      </BootstrapGate>
    </AdminThemeProvider>
  </StrictMode>,
);
